import React from "react";

export default function CancelComponentCCA(props) {
	console.log(props)
	return "Payment Cancelled";
}